import { v4 as uuidV4 } from "uuid"
import { create } from "zustand"

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/
type SignupRequestStoreData = {
  initialHref: string
  sessionId: string
  fromPdv: boolean
  typUrl: string
  flagAdvPlus: boolean
  billCodeId?: string | null
  mppartner: string | null
  phoneNumberAlreadyPresentCounter: number
  bonusCodeAlreadyPresentCounter: number
  pdvKoCheckCrendentialsCounter: number
  accountId: number | null
  activePromoCode?: string | null
  intcmpFromSearchParams?: string
}

type SignupRequestStore = {
  data: SignupRequestStoreData
  setData: (data: Partial<SignupRequestStoreData>) => void
  incrementPhoneAlreadyPresentCounter: () => void
  incrementBonuCodeAlreadyPresentCounter: () => void
  incrementPdvCheckCredentialsCounter: () => void
  reset: () => void
}

/* -------------------------------------------------------------------------------------------------
 * config
 * -----------------------------------------------------------------------------------------------*/

const initialState: SignupRequestStoreData = {
  initialHref: "",
  sessionId: uuidV4(),
  fromPdv: false,
  flagAdvPlus: false,
  typUrl: "",
  billCodeId: null,
  mppartner: null,
  phoneNumberAlreadyPresentCounter: 0,
  bonusCodeAlreadyPresentCounter: 0,
  pdvKoCheckCrendentialsCounter: 0,
  accountId: null,
  activePromoCode: null,
  intcmpFromSearchParams: undefined,
}

/* -------------------------------------------------------------------------------------------------
 * store
 * -----------------------------------------------------------------------------------------------*/
const useSignupRequestStore = create<SignupRequestStore>((set) => ({
  data: initialState,
  setData: (data) => {
    set((state) => {
      state.data = { ...state.data, ...data }
      return state
    })
  },
  incrementBonuCodeAlreadyPresentCounter: () =>
    set((state) => ({
      ...state,
      data: {
        ...state.data,
        bonusCodeAlreadyPresentCounter:
          state.data.bonusCodeAlreadyPresentCounter + 1,
      },
    })),
  incrementPhoneAlreadyPresentCounter: () =>
    set((state) => ({
      ...state,
      data: {
        ...state.data,
        phoneNumberAlreadyPresentCounter:
          state.data.phoneNumberAlreadyPresentCounter + 1,
      },
    })),
  incrementPdvCheckCredentialsCounter: () =>
    set((state) => ({
      ...state,
      data: {
        ...state.data,
        pdvKoCheckCrendentialsCounter:
          state.data.pdvKoCheckCrendentialsCounter + 1,
      },
    })),
  reset: () => set({ data: initialState }),
}))

export default useSignupRequestStore
